import React from 'react';
import { cn } from '../../utils/cn';
export function Notification({ className, children, accessory, ...rest }) {
    return (React.createElement("div", Object.assign({ className: cn(className, 'bg-smudge', 'flex flex-row items-center justify-between', 'min-w-0 min-h-0', 'p-2 space-x-2') }, rest),
        children,
        accessory));
}
